import { render, staticRenderFns } from "./aliTypes.vue?vue&type=template&id=d6d2af78"
import script from "./aliTypes.vue?vue&type=script&lang=js"
export * from "./aliTypes.vue?vue&type=script&lang=js"
import style0 from "./aliTypes.vue?vue&type=style&index=0&id=d6d2af78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports